import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Flex, RadioChangeEvent } from 'antd';
import React, { FC, useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormField, FormRadioGroup } from '../../../../common/form';
import translations from './AlgorithmConfidentialityRuleFormField.translations.json';
import { AlgorithmConfidentialityRuleSourceDimensionFormField } from './AlgorithmConfidentialityRuleSourceDimensionFormField';
import { AlgorithmSourcesValidFormDataType } from '../schema/types';
import { useIsAlgorithmConfidentialityRuleSourceDimensionEditable } from './useIsAlgorithmConfidentialityRuleSourceDimensionEditable';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-confidentiality-rule-form-field'
);
addTranslations(translations);

interface AlgorithmConfidentialityRuleFormFieldProps {
  dataObjectConfidentialityStatusId?: number;
}

export const AlgorithmConfidentialityRuleFormField: FC<
  AlgorithmConfidentialityRuleFormFieldProps
> = (props) => {
  const { dataObjectConfidentialityStatusId } = props;
  const isEditable = useIsAlgorithmConfidentialityRuleSourceDimensionEditable(
    dataObjectConfidentialityStatusId
  );

  if (!isEditable) {
    return null;
  }

  return <AlgorithmConfidentialityRuleFormFieldInner />;
};

export const AlgorithmConfidentialityRuleFormFieldInner: FC = () => {
  const { t } = useTranslation();

  const useDimensionOptions = useMemo(
    () => [
      {
        value: false,
        label: t('useDimension.false.label'),
      },
      {
        value: true,
        label: t('useDimension.true.label'),
      },
    ],
    [t]
  );

  const { setValue } = useFormContext<AlgorithmSourcesValidFormDataType>();
  const isUseDimension = useWatch<AlgorithmSourcesValidFormDataType>({
    name: 'confidentialityRule.useDimension',
  });

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      if (!event.target.value) {
        setValue('confidentialityRule.source', null);
      }
    },
    [setValue]
  );

  return (
    <Flex gap="middle">
      <FormField
        name="confidentialityRule.useDimension"
        label={t('useDimension.label')}
        required
      >
        <FormRadioGroup
          name="confidentialityRule.useDimension"
          options={useDimensionOptions}
          onChange={handleChange}
        />
      </FormField>
      {isUseDimension && (
        <AlgorithmConfidentialityRuleSourceDimensionFormField />
      )}
    </Flex>
  );
};
